/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSON, FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSON, } from './FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile';
import { FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSON, FxIdDomainSettingsPortalPublicWebConfigOptionsToJSON, } from './FxIdDomainSettingsPortalPublicWebConfigOptions';
/**
 * Check if a given object implements the FxIdWebFeaturesGamesChooseGamePortalConfig interface.
 */
export function instanceOfFxIdWebFeaturesGamesChooseGamePortalConfig(value) {
    if (!('PortalPublicWebConfig' in value) || value['PortalPublicWebConfig'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigFromJSON(json) {
    return FxIdWebFeaturesGamesChooseGamePortalConfigFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'PortalPublicWebConfig': FxIdDomainSettingsPortalPublicWebConfigOptionsFromJSON(json['PortalPublicWebConfig']),
        'Turnstile': json['Turnstile'] == null ? undefined : FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSON(json['Turnstile']),
    };
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigToJSON(json) {
    return FxIdWebFeaturesGamesChooseGamePortalConfigToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'PortalPublicWebConfig': FxIdDomainSettingsPortalPublicWebConfigOptionsToJSON(value['PortalPublicWebConfig']),
        'Turnstile': FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSON(value['Turnstile']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesGamesChooseGamePortalConfig.js.map